import {
  deprecated,
  deprecatedObjectProperty,
  deprecatedProperty
} from "./chunk-UEY4AZIP.mjs";
import "./chunk-7HPDNZ3R.mjs";
import "./chunk-7ELT755Q.mjs";
export {
  deprecated,
  deprecatedObjectProperty,
  deprecatedProperty
};
//# sourceMappingURL=deprecated.mjs.map